import { Page } from "@/models/page-models/Page";

export const ComplaintMasterByCustomer: Page = {
  "path": "complaint-master/:customerId",
  "name": "Complaint Master",
  "props": {
    "data": {
      "title": "Complaint",
      "printable": "FALSE",
      "url": "complaint-master/:customerId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.customer",
                  "label": "Select Customer",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToComplaintMaster",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/complaint-master/{{fetchedData.customer}}"
                      },
                      "name": "redirectToComplaintMaster"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                },
                {
                  "type": "button",
                  "label": "Create New Complaint",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openNewComplaintPage",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/new-complaint",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"customer\":\"{{fetchedData.customer}}\"}"
                      },
                      "name": "openNewComplaintPage"
                    }
                  ],
                  "disabled": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.customerDetails.status}},'),==,'Pending Prospect'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.customerDetails.status}},'),==,'Closed Prospect'))",
                  "showIf": "fn(MATCH_DEPARTMENT,SALES)",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Reject Complaint",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.rejectionForm.reason",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "itemVariable": "fetchedData.selectedComplaint",      
          "popupActions": [
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectComplaint",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/mark-rejected",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.rejectionForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "rejectComplaint"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeRejectionPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Reject Complaint"
                  },
                  "name": "closeRejectionPopup"
                }
              ]
            }
          ]
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Open",
              "bracketValueFormula": "{{fetchedData.openComplaints.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Open Complaints",
                      "disabled": "FALSE",
                      "items": "fetchedData.openComplaints.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Complaint",
                          "type": "url",
                          "url": "/complaint/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.complaintType",
                          "text": "Type"
                        },
                        {
                          "value": "__item.invoice",
                          "text": "Invoice",
                          "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.defectiveQuantity",
                          "text": "Defective Quantity"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Complete",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,GENERAL_MANAGER))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markComplaintComplete",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/mark-completed",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "markComplaintComplete"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedTableItem"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openRejectionPopup"
                            }
                          ]
                        },
                        {
                          "label": "Hold",
                          "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "holdComplaint",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/hold",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "holdComplaint"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.openComplaintSearchForm.page",
                        "serverItemsLengthVariable": "fetchedData.openComplaints.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.openComplaintSearchForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getOpenComplaints",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/customer-complaint/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.openComplaints",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.openComplaintSearchForm"
                            },
                            "name": "getOpenComplaints"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Pending",
              "bracketValueFormula": "{{fetchedData.pendingComplaints.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Complaints",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingComplaints.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Complaint",
                          "type": "url",
                          "url": "/complaint/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.complaintType",
                          "text": "Type"
                        },
                        {
                          "value": "__item.invoice",
                          "text": "Invoice",
                          "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.defectiveQuantity",
                          "text": "Defective Quantity"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveComplaint",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "approveComplaint"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedTableItem"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openRejectionPopup"
                            }
                          ]
                        },
                        {
                          "label": "Hold",
                          "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "holdComplaint",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/hold",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "holdComplaint"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingComplaintSearch.page",
                        "serverItemsLengthVariable": "fetchedData.pendingComplaints.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.pendingComplaintSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getPendingComplaints",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/customer-complaint/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.pendingComplaints",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.pendingComplaintSearch"
                            },
                            "name": "getPendingComplaints"
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Hold",
              "bracketValueFormula": "{{fetchedData.onHoldComplaints.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "On Hold Complaints",
                      "disabled": "FALSE",
                      "items": "fetchedData.onHoldComplaints.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Complaint",
                          "type": "url",
                          "url": "/complaint/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.complaintType",
                          "text": "Type"
                        },
                        {
                          "value": "__item.invoice",
                          "text": "Invoice",
                          "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.defectiveQuantity",
                          "text": "Defective Quantity"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Remove Hold",
                          "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER))))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "removeHold",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/unHold",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "removeHold"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedTableItem"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openRejectionPopup"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,

                      "pagination": {
                        "pageVariable": "fetchedData.onHoldComplaintForm.page",
                        "serverItemsLengthVariable": "fetchedData.onHoldComplaints.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.onHoldComplaintForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getOnHoldComplaints",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/customer-complaint/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.onHoldComplaints",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.onHoldComplaintForm"
                            },
                            "name": "getOnHoldComplaints"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Rejected",
              "bracketValueFormula": "{{fetchedData.rejectedComplaints.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Rejected Complaints",
                      "disabled": "FALSE",
                      "items": "fetchedData.rejectedComplaints.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Complaint",
                          "type": "url",
                          "url": "/complaint/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.complaintType",
                          "text": "Type"
                        },
                        {
                          "value": "__item.invoice",
                          "text": "Invoice",
                          "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.defectiveQuantity",
                          "text": "Defective Quantity"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "pagination": {
                        "pageVariable": "fetchedData.rejectedComplaintForm.page",
                        "serverItemsLengthVariable": "fetchedData.rejectedComplaints.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.rejectedComplaintForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getRejectedComplaints",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/customer-complaint/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.rejectedComplaints",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.rejectedComplaintForm"
                            },
                            "name": "getRejectedComplaints"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Complete",
              "bracketValueFormula": "{{fetchedData.completeComplaints.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Complete Complaints",
                      "disabled": "FALSE",
                      "items": "fetchedData.completeComplaints.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Complaint",
                          "type": "url",
                          "url": "/complaint/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.complaintType",
                          "text": "Type"
                        },
                        {
                          "value": "__item.invoice",
                          "text": "Invoice",
                          "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.defectiveQuantity",
                          "text": "Defective Quantity"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "pagination": {
                        "pageVariable": "fetchedData.completeComplaintForm.page",
                        "serverItemsLengthVariable": "fetchedData.completeComplaints.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.completeComplaintForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getCompleteComplaints",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/customer-complaint/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.completeComplaints",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.completeComplaintForm"
                            },
                            "name": "getCompleteComplaints"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyCustomerId",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "__params.customerId",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Number"
        },
        "name": "copyCustomerId"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 4,
        "pageFunction": {
          "name": "copyCustomerData",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getCustomerData",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerDetails"
        },
        "name": "copyCustomerData"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingComplaintSearchForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingComplaintSearchForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingComplaintSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingComplaintSearchForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToPendingComplaintSearchForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.pendingComplaintSearch.q.customer"
        },
        "name": "pushCustomerIdToPendingComplaintSearchForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getPendingComplaints",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/customer-complaint/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.pendingComplaints",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.pendingComplaintSearch"
        },
        "name": "getPendingComplaints"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOpenComplaintForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOpenComplaintForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.openComplaintSearchForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultOpenComplaintForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToOpenComplaintSearchForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.openComplaintSearchForm.q.customer"
        },
        "name": "pushCustomerIdToOpenComplaintSearchForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getOpenComplaints",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/customer-complaint/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.openComplaints",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.openComplaintSearchForm"
        },
        "name": "getOpenComplaints"
      },
      {
        "executionOrder": 1,
        "name": "copyDefaultOnHoldComplaintForm",
        "pageFunction": {
          "name": "copyDefaultOnHoldComplaintForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOnHoldComplaintForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.onHoldComplaintForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        }
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToOnHoldComplaintSearchForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.onHoldComplaintForm.q.customer"
        },
        "name": "pushCustomerIdToOnHoldComplaintSearchForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getOnHoldComplaints",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/customer-complaint/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.onHoldComplaints",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.onHoldComplaintForm"
        },
        "name": "getOnHoldComplaints"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCompleteComplaintForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCompleteComplaintForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.completeComplaintForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultCompleteComplaintForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToCompleteComplaintSearchForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.completeComplaintForm.q.customer"
        },
        "name": "pushCustomerIdToCompleteComplaintSearchForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getCompleteComplaints",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/customer-complaint/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.completeComplaints",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.completeComplaintForm"
        },
        "name": "getCompleteComplaints"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultRejectedComplaintForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultRejectedComplaintForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.rejectedComplaintForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultRejectedComplaintForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToRejectedComplaintSearchForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.rejectedComplaintForm.q.customer"
        },
        "name": "pushCustomerIdToRejectedComplaintSearchForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getRejectedComplaints",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/customer-complaint/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.rejectedComplaints",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.rejectedComplaintForm"
        },
        "name": "getRejectedComplaints"
      }
    ],
    "functions": [
      {
        "name": "getDefaultPendingComplaintSearchForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Pending"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultOpenComplaintForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Open"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "copySelectedTableItem",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedComplaint",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object"
      },
      {
        "name": "openRejectionPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Reject Complaint"
      },
      {
        "name": "getDefaultOnHoldComplaintForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Hold"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultCompleteComplaintForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Complete"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultRejectedComplaintForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Rejected"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getCustomerData",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.customers.data",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.customer"
      }
    ]
  },
  "forRole": "GENERAL_MANAGER,QA_MANAGER,SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,QA_TECHNICAL_EXECUTIVE,QA_QUALITY_EXECUTIVE,PRODUCTION_MANAGER,CUSTOMER_SERVICE_MANAGER",
  "visible": true,
  "routerPriority": 74
}